import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Trash: FC<IIconsProps> = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.07789 21L5.06948 6H18.9305L17.9221 21L6.07789 21Z"
        stroke={color}
        strokeWidth="2"
      />
      <path d="M8 3L16 3V6H8V3Z" stroke={color} strokeWidth="2" />
      <line
        x1="3"
        y1="6"
        x2="21"
        y2="6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="10"
        y1="10"
        x2="10"
        y2="15"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="14"
        y1="10"
        x2="14"
        y2="15"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Trash;
